import {combineReducers} from 'redux';
import hsseDash from './hsse';
import fuse from './fuse';
import auth from 'app/auth/store/reducers';

const createReducer = (asyncReducers) =>
    combineReducers({
        auth,
        fuse,
        hsseDash,
        ...asyncReducers
    });

export default createReducer;
